import type { TireStatus, TirePosition } from '../types';

// Utility functions for TreadAI tire inspection platform
export const cn = (...classes: (string | undefined | null | false)[]) => {
  return classes.filter(Boolean).join(' ');
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatDateShort = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
};

export const getTirePositionLabel = (position: TirePosition): string => {
  const labels: Record<TirePosition, string> = {
    FL: 'Front Left',
    FR: 'Front Right',
    RL: 'Rear Left',
    RR: 'Rear Right',
  };
  return labels[position];
};

export const getStatusColor = (
  status: TireStatus
): { bg: string; text: string; border: string } => {
  switch (status) {
    case 'ok':
      return {
        bg: 'bg-green-100',
        text: 'text-green-800',
        border: 'border-green-200',
      };
    case 'watch':
      return {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        border: 'border-yellow-200',
      };
    case 'replace_soon':
      return {
        bg: 'bg-orange-100',
        text: 'text-orange-800',
        border: 'border-orange-200',
      };
    case 'unsafe':
      return {
        bg: 'bg-red-100',
        text: 'text-red-800',
        border: 'border-red-200',
      };
    default:
      // Fallback for any unexpected status values
      return {
        bg: 'bg-gray-100',
        text: 'text-gray-800',
        border: 'border-gray-200',
      };
  }
};

export const getStatusLabel = (status: TireStatus): string => {
  switch (status) {
    case 'ok':
      return 'Good';
    case 'watch':
      return 'Review';
    case 'replace_soon':
      return 'Replace soon';
    case 'unsafe':
      return 'Replace';
    default:
      return 'Unknown';
  }
};

export const getWearPatternLabel = (
  pattern: string
): string => {
  switch (pattern) {
    case 'even':
      return 'Even';
    case 'inner_edge':
      return 'Inner Edge';
    case 'outer_edge':
      return 'Outer Edge';
    case 'center':
      return 'Center';
    default:
      return pattern;
  }
};
